import script from "./RevenuesTableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenuesTableComponent.vue?vue&type=script&setup=true&lang=js"

import "./RevenuesTableComponent.vue?vue&type=style&index=0&id=38d30341&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d30341"]])

export default __exports__